import { render, staticRenderFns } from "./GeneralButton.vue?vue&type=template&id=587c99e2&scoped=true&"
import script from "./GeneralButton.vue?vue&type=script&lang=js&"
export * from "./GeneralButton.vue?vue&type=script&lang=js&"
import style0 from "./GeneralButton.vue?vue&type=style&index=0&id=587c99e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587c99e2",
  null
  
)

export default component.exports